/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as a from "react";
import { PDFMargin as s } from "./PDFMargin.mjs";
const i = ["bottom", "left", "right", "top"];
function l(e) {
  const n = a.Children.toArray(e.children).find((t) => t && t.type === s);
  return n ? f(n) : e.margin;
}
function f(e) {
  const n = {};
  for (let t = 0; t < i.length; t++) {
    const r = i[t], o = e.props[r];
    o !== void 0 && (n[r] = o);
  }
  return n;
}
export {
  l as getPageMargin
};
